import { render } from "./AddFacebookPage.vue?vue&type=template&id=95b16dee&scoped=true"
import script from "./AddFacebookPage.vue?vue&type=script&lang=js"
export * from "./AddFacebookPage.vue?vue&type=script&lang=js"

import "./AddFacebookPage.vue?vue&type=style&index=0&id=95b16dee&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95b16dee"]])

export default __exports__